import { createSlice } from "@reduxjs/toolkit";
import { ICustomerTaxExemptionResponse } from "../../typings/interfaces/responses/customerTaxExemptionResponse";
import {
  addTaxExemption,
  deleteTaxExemption,
  getTaxExemptionByCustomer,
  updateTaxExemption,
} from "../actions/taxExemptionAction";

export interface TaxExemptionState {
  currentExemption: ICustomerTaxExemptionResponse | null;
  fetchLoading: boolean;
  fetchError: string | null;
  mutationLoading: boolean;
  mutationError: string | null;
}

const initialState: TaxExemptionState = {
  currentExemption: null,
  fetchLoading: false,
  fetchError: null,
  mutationLoading: false,
  mutationError: null,
};

const taxExemptionSlice = createSlice({
  name: "taxExemption",
  initialState,
  reducers: {
    clearTaxExemption: (state: TaxExemptionState) => {
      state.currentExemption = null;
      state.fetchError = null;
      state.fetchLoading = false;
      state.mutationError = null;
      state.mutationLoading = false;
    },
  },
  extraReducers: (builder) => {
    // GET
    builder.addCase(getTaxExemptionByCustomer.pending, (state) => {
      state.fetchLoading = true;
      state.fetchError = null;
    });
    builder.addCase(getTaxExemptionByCustomer.fulfilled, (state, action) => {
      state.fetchLoading = false;
      state.currentExemption = action.payload?.body ?? null;
    });
    builder.addCase(getTaxExemptionByCustomer.rejected, (state) => {
      state.fetchLoading = false;
      // 404 means no exemption exists — not an error, just null
      state.currentExemption = null;
    });

    // ADD
    builder.addCase(addTaxExemption.pending, (state) => {
      state.mutationLoading = true;
      state.mutationError = null;
    });
    builder.addCase(addTaxExemption.fulfilled, (state, action) => {
      state.mutationLoading = false;
      state.currentExemption = action.payload?.body ?? null;
    });
    builder.addCase(addTaxExemption.rejected, (state, action) => {
      state.mutationLoading = false;
      state.mutationError = action.payload as string;
    });

    // UPDATE
    builder.addCase(updateTaxExemption.pending, (state) => {
      state.mutationLoading = true;
      state.mutationError = null;
    });
    builder.addCase(updateTaxExemption.fulfilled, (state, action) => {
      state.mutationLoading = false;
      state.currentExemption = action.payload?.body ?? null;
    });
    builder.addCase(updateTaxExemption.rejected, (state, action) => {
      state.mutationLoading = false;
      state.mutationError = action.payload as string;
    });

    // DELETE
    builder.addCase(deleteTaxExemption.pending, (state) => {
      state.mutationLoading = true;
      state.mutationError = null;
    });
    builder.addCase(deleteTaxExemption.fulfilled, (state) => {
      state.mutationLoading = false;
      state.currentExemption = null;
    });
    builder.addCase(deleteTaxExemption.rejected, (state, action) => {
      state.mutationLoading = false;
      state.mutationError = action.payload as string;
    });
  },
});

export default taxExemptionSlice.reducer;
export const TaxExemptionSliceActions = taxExemptionSlice.actions;
